import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { fetchDocList } from '@repository/docListsRepository';
import { minutesToMillis } from '@utils/millis';
import { FetchDocListError, FetchDocListResponse } from '@models/docList/FetchDocList';

const useFetchDocList = (docClass?: string, listType?: string, config?: object) => {
    return useQuery<FetchDocListResponse, FetchDocListError>({
        queryKey: [QueryKey.DocList, docClass, listType],
        queryFn: ({ signal }) => {
            if (!docClass || !listType) {
                return Promise.reject();
            }
            return fetchDocList(docClass, listType, { signal });
        },
        enabled: !!docClass && !!listType,
        staleTime: minutesToMillis(2),
        ...config,
    });
};

export default useFetchDocList;
